/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_PlayerInputs */

const th_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดข้อมูลผู้เล่น…`)
};

const en_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading player…`)
};

const ja_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選手情報を読み込み中…`)
};

const zh_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载球员…`)
};

const es_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando jugador…`)
};

const pt_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando jogador…`)
};

const id_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat pemain…`)
};

const fr_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement du joueur…`)
};

const tl_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilo-load ang manlalaro…`)
};

const vi_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải cầu thủ…`)
};

const ko_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수를 불러오는 중…`)
};

const de_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spieler wird geladen…`)
};

const ru_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загружаем игрока…`)
};

const tr_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyuncu yükleniyor…`)
};

const it_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento giocatore…`)
};

const pl_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie zawodnika…`)
};

const uk_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажуємо гравця…`)
};

const hi_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खिलाड़ी लोड हो रहा है…`)
};

const ar_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل اللاعب…`)
};

const ms_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat pemain…`)
};

const bn_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলোয়াড় লোড হচ্ছে…`)
};

const zh_tw2_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入球員…`)
};

const zh_hk2_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入球員…`)
};

const ur_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کھلاڑی لوڈ ہو رہا ہے…`)
};

const fa_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال بارگذاری بازیکن…`)
};

const sw_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia mchezaji…`)
};

const nl_loading_player = /** @type {(inputs: Loading_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speler laden…`)
};

/**
* | output |
* | --- |
* | "Loading player…" |
*
* @param {Loading_PlayerInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const loading_player = /** @type {((inputs?: Loading_PlayerInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_PlayerInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_loading_player(inputs)
	if (locale === "ja") return ja_loading_player(inputs)
	if (locale === "zh") return zh_loading_player(inputs)
	if (locale === "es") return es_loading_player(inputs)
	if (locale === "pt") return pt_loading_player(inputs)
	if (locale === "id") return id_loading_player(inputs)
	if (locale === "fr") return fr_loading_player(inputs)
	if (locale === "tl") return tl_loading_player(inputs)
	if (locale === "vi") return vi_loading_player(inputs)
	if (locale === "ko") return ko_loading_player(inputs)
	if (locale === "de") return de_loading_player(inputs)
	if (locale === "ru") return ru_loading_player(inputs)
	if (locale === "tr") return tr_loading_player(inputs)
	if (locale === "it") return it_loading_player(inputs)
	if (locale === "pl") return pl_loading_player(inputs)
	if (locale === "uk") return uk_loading_player(inputs)
	if (locale === "hi") return hi_loading_player(inputs)
	if (locale === "ar") return ar_loading_player(inputs)
	if (locale === "ms") return ms_loading_player(inputs)
	if (locale === "bn") return bn_loading_player(inputs)
	if (locale === "zh-TW") return zh_tw2_loading_player(inputs)
	if (locale === "zh-HK") return zh_hk2_loading_player(inputs)
	if (locale === "ur") return ur_loading_player(inputs)
	if (locale === "fa") return fa_loading_player(inputs)
	if (locale === "sw") return sw_loading_player(inputs)
	if (locale === "nl") return nl_loading_player(inputs)
	return en_loading_player(inputs)
});